export const GetTokboxToken = (session: string) => fetch(`${process.env.REACT_APP_API_HOST}/get-tokbox-token`, {
	method: 'POST',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
	body: JSON.stringify({
		sessionId: session,
	}),
}).then((res) => {
	if (res.ok) return res.json();
	return res.status;
}).catch((e) => e);

export const GetSession = () => fetch(`${process.env.REACT_APP_API_HOST}/v2/opentok/session`, {
	method: 'GET',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
	},
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return res.status;
}).catch((e) => e);

export const SetStreamInfo = (
	token: string,
	stream_id: string,
	archive_id: string,
	session: string,
	gr_user: number,
	meeting: number,
	device_type: string | null,
) => fetch(`${process.env.REACT_APP_API_HOST}/v2/opentok/stream`, {
	method: 'POST',
	headers: {
		Accept: 'application/json',
		'Content-Type': 'application/json',
		'bl-token': token,
	},
	body: JSON.stringify({
		stream_id,
		archive_id,
		session,
		gr_user,
		meeting,
		device_type,
	}),
}).then((res) => {
	if (res.ok) {
		return res.json();
	}
	return res.status;
}).catch((e) => e);
